import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from '@material-ui/core';

class RadiateurIcon extends PureComponent {
    static propTypes = {
        size: PropTypes.number,
        color: PropTypes.string
    };

    static defaultProps = {
        size: 50,
        color: '#8e8e8e'
    };

    render() {
        const { color, size } = this.props;
        return (
            <svg height={(size / 1.5).toString()} width={(size / 1.5).toString()} viewBox="0 0 300 300">
                <g fill={color}>
                    <rect x={248.19} width={51.81} height={300} rx={25.9} ry={25.9} />
                    <rect x={112.93} width={51.81} height={300} rx={25.9} ry={25.9} />
                    <rect x={180.56} width={51.81} height={300} rx={25.9} ry={25.9} />
                    <path d="M70.41 0c-14.17.45-25.1 13.25-25.1 27.92v22H22.12v-9.15H11.79A12 12 0 0 0 0 53v47.5a12 12 0 0 0 11.79 12.2h10.33v-9.16h23.19v168.54c0 14.67 10.93 27.47 25.11 27.91 14.67.46 26.7-11.71 26.7-26.79V26.8C97.11 11.73 85.08-.44 70.41 0z" />
                </g>
            </svg>
        );
    }
}

export default withTheme(RadiateurIcon);



// WEBPACK FOOTER //
// ./data/common/iconsvg/RadiateurIcon.js